import React from 'react';
import { Box, Container, Fade, Paper, Typography, Button, useTheme } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { useLocation, useNavigate } from 'react-router';
import { ROUTE_PATHS } from '../../utils/Routes';

type LocationProps = {
	state: {
		unsupportedOnPortal: string;
	};
};

const BackOfficePaymentSessionSuccessPage: React.FC = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const location = useLocation() as unknown as LocationProps;

	return (
		<Fade in timeout={400}>
			<Paper
				elevation={1}
				sx={{
					mt: theme.spacing(3),
					padding: { md: theme.spacing(3), sm: 0, xs: 0 },
					borderRadius: '8px',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					backgroundColor: theme.palette.background.paper,
				}}
			>
				<Container maxWidth='sm'>
					<Box my={4} textAlign='center'>
						<CheckCircleOutlineIcon sx={{ fontSize: 100, color: theme.palette.success.main }} />
						<Typography variant='h5' gutterBottom>
							Thank you for your payment details!
						</Typography>
						<Typography variant='subtitle1'>
							Please let our agent know your payment details have been successfully processed.
						</Typography>
					</Box>
					{location.state?.unsupportedOnPortal === 'false' && (
						<Box
							mt={3}
							textAlign='center'
							sx={{
								border: `1px solid ${theme.palette.primary.main}`,
								borderRadius: '4px',
								padding: theme.spacing(3),
								my: 2,
							}}
						>
							<Typography variant='body1' gutterBottom>
								If you haven&apos;t already, why not register for our customer portal using the email associated with
								your policy.
							</Typography>
							<Button
								variant='contained'
								color='primary'
								fullWidth
								size='large'
								startIcon={<PersonAddIcon />}
								sx={{ mt: 2 }}
								onClick={() => navigate(ROUTE_PATHS.register)}
							>
								Register Now
							</Button>
						</Box>
					)}
				</Container>
			</Paper>
		</Fade>
	);
};

export default BackOfficePaymentSessionSuccessPage;
